<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Editar Área <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-2">
                        <div class="text-center m-b-lg margin-top-20">
                            <img :src="team.photo" width="160px">
                        </div>
                    </div>
                    <div class="form-group col-md-10">
                        <label for="name"><span class="required">*</span> Nome da Área</label>
                        <input type="text" class="form-control" name="name" v-model="team.name" id="name">
                    </div>
                    <div class="form-group col-md-10">
                        <label for="photofile">Foto</label>
                        <input type="file" name="photofile" id="photofile" class="form-control">
                    </div>
                    <div class="form-group col-md-10" style="display:flex">
                        <label for="viewAllEvents">Visualização de todos os eventos</label>
                        <input v-model="team.viewAllEvents" type="checkbox" name="viewAllEvents" id="viewAllEvents" style="width:30px;height:15px">
                    </div>
                </div>
            </div>
			<div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/teams" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>


<script>
    export default {
        data() {
            return {
                team: {
                    name: '',
                    photo: '',
                    viewAllEvents: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'teams/' + id;

                let form  = new FormData();
                let photo = document.getElementById('photofile');

                form.append('name', self.team.name);
                form.append('viewAllEvents', self.team.viewAllEvents ? 1 : 0);
                form.append('photofile', (photo.files[0]) ? photo.files[0] : null);
                form.append('_method', 'PUT');

                self.$http.post(api, form)
                    .then((response) => {
                        self.$message('Sucesso', `Área atualizada com sucesso`, 'success');
                        this.$router.push('/teams');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getTeam(){
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'teams/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.team = response.data.data[0];
                    })
                    .catch((error) => {
                       self.$message(null, 'Ocorreu um erro ao buscar as informações do Cargo', 'error');
                    });
            }
        },
        mounted: function(){
            this.getTeam();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-top-20 {
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Team/Edit.vue